import axios from 'axios';
import authHeader from '../auth-header';
import UtilService from '../utils.service'
import tokenHeader from '../token-header';

// const API_URL = 'https://localhost:9090/api/all/';
import baseUrl from '../base-url';

const API_LMS = UtilService.baseUrlLms()+'/';
const API_URL = baseUrl() + "/api/all/";

const getPelatihan = 'get_all_course';
const downloadSKP = 'data-peserta-pelatihan-export';
const getListInstruktur = 'get-list-instruktur-course/';


class PelatihanOnlineService {
    getWorkshop(currentPage, pageSize,filter,statusPublish) {
        var data = {
            page : currentPage,
            pageSize : pageSize,
            filter : filter,
            status : status,
            statusPublish : statusPublish
        }

        return axios.get(
            API_LMS + getPelatihan, {
            params : data,
        });
    }
    
    getListInstruktur(idCourse) {
        return axios.get(
            API_LMS + getListInstruktur + idCourse);
    }

    downloadSKP(pelatihan, periode) {
        return axios.get(
            API_URL + downloadSKP + '?idWorkshopPelatihan=' + pelatihan + '&periode=' + periode,
            {
                headers: authHeader(),
                responseType: 'blob'
            });
    }

}

export default new PelatihanOnlineService();